"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingWeekAside = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const TrainingInfoBar_1 = __importDefault(require("./TrainingInfoBar"));
const hooks_1 = require("../../shared/hooks");
const TrainingWeekAside = (props) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    if (!isMobile) {
        return ((0, jsx_runtime_1.jsx)(TrainingInfoBar_1.default, { trainingsTitle: props.title, trainingsValue: props.progressBarTitle, ratingTitle: props.ratingTitle, ratingValue: props.rating.rating, activitiesTitle: props.activitiesTitle, activitiesValue: props.activitiesValue }, void 0));
    }
    return null;
};
exports.TrainingWeekAside = TrainingWeekAside;
//# sourceMappingURL=TrainingWeekAside.js.map